import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import AccountantHubPage from '../ui/pages/AccountantHubPage/view';
import ProfilePage from '../ui/pages/profile/view';
import GeneralLayout from '../ui/templates/view';

/**
 * Accountant Role Class
 * Defines the routing behavior for users with the accountant role.
 */
export class Accountant {
    getRoutes() {
        return (
            <Router>
                <Routes>
                    {/* Main Hub for Accountants */}
                    <Route
                        path="/accountant-hub"
                        element={<GeneralLayout child={<AccountantHubPage />} />}
                    />

                    {/* Profile Page for Accountants */}
                    <Route
                        path="/profile"
                        element={<GeneralLayout child={<ProfilePage />} />}
                    />

                    {/* Fallback to Hub */}
                    <Route path="/" element={<Navigate to="/accountant-hub" replace />} />

                    {/* Catch all for unauthorized paths within this role */}
                    <Route path="*" element={<Navigate to="/accountant-hub" replace />} />
                </Routes>
            </Router>
        );
    }
}
